import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const baseApi = createApi({
  reducerPath: "api",

  // Silently refreshes an expired access token (and retries), or forces logout
  // when the refresh token is gone — see baseQueryWithReauth.
  baseQuery: baseQueryWithReauth,

  // Refetch a query when its component remounts (i.e. when you navigate to a
  // screen). Keeps admin lists fresh — e.g. an org created via self-serve
  // signup shows up when the platform owner opens Organizations/Subscriptions
  // without a manual refresh. Cross-session writes can't push invalidations.
  refetchOnMountOrArgChange: true,

  // Every module's `providesTags` / `invalidatesTags` must reference a tag
  // declared here, otherwise RTK Query ignores cache invalidation.
  tagTypes: [
    "Auth",
    "User",
    "Organization",
    "UserOrganization",
    "Subscription",
    "SubscriptionUpgradeRequest",
    "Product",
    "Warehouse",
    "StockLevel",
    "StockAdjustment",
    "Category",
    "Customer",
    "Factory",
    "Brand",
    "Supplier",
    "Order",
    "Sale",
    "Invoice",
    "Payment",
    "Plan",
    "Broker",
    "Enterprise",
    "RateLimit",
    "ApiUsage",
    "TableLayout",
    "Trash",
    "AppConfig",
    "EmailConfig",
    "EmailTemplate",
    "Asset",
    "OrphanAsset",
  ],

  endpoints: () => ({}),
});
